module.exports = __webpack_public_path__ + "Bliss2-Italic.356b8a96d37d40b36d63.woff2";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/Bliss2-Italic.woff2
// module id = ../../../../../src/assets/layout/fonts/Bliss2-Italic.woff2
// module chunks = styles